import type { ReactNode } from "react";

interface SettingsRowProps {
  label: ReactNode;
  hint?: ReactNode;
  children: ReactNode;
}

export function SettingsRow({ label, hint, children }: SettingsRowProps) {
  return (
    <div className="grid grid-cols-1 gap-3 py-3.5 sm:grid-cols-[minmax(180px,240px)_1fr] sm:gap-6">
      <div className="pt-1.5">
        <div className="text-[13px] font-medium text-foreground">{label}</div>
        {hint && <div className="mt-0.5 max-w-[220px] text-[11.5px] text-muted-foreground">{hint}</div>}
      </div>
      <div className="min-w-0">{children}</div>
    </div>
  );
}
